module.exports = __webpack_public_path__ + "nstatic/img/erlangshenLOGO.2616cc98.png";